import axios from "axios";
import { getCached, setCached } from "../utilsfolder/cache";
import apiClient from "../api/client"; 

/* ---------PUT Request for Save ---------------- */
export const updateRolePermissions = async (roleId, permissionsData) => {
  const payload = { permissions: permissionsData };

  const res = await apiClient.put(`/api/admin/role-menu-access/${roleId}`, payload);
  return res.data;
};
/* ───────── Role Menu Access (Permissions Table) ───────── */
/* ───────── Role Menu Access (Permissions Table) ───────── */
export const getRoleMenuAccess = async (roleId) => {
  try {
    const res = await apiClient.get(`/api/admin/role-menu-access-tree/${roleId}`);
    return res.data;
  } catch (error) {
    console.error(`Failed to fetch role-menu-access for role ${roleId}:`, error.response?.data || error);
    throw error;
  }
};
// masterDataService.js
export const getMenuById = async (menuId) => {
  try {
    const res = await apiClient.get(`/api/admin/menus/${menuId}`);
    return res.data;
  } catch (error) {
    console.error(`Failed to fetch menu for ID ${menuId}:`, error.response?.data || error);
    throw error;
  }
};

export const getAllMenuMaster = async () => {
  try {
    const res = await apiClient.get(`/api/admin/menusmaster`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch all menus:", error.response?.data || error);
    throw error;
  }
};

export const updateMenu = async (menuId, payload) => {
  try {
    const res = await apiClient.put(`/api/admin/menus/${menuId}`, payload);
    return res.data;
  } catch (error) {
    console.error(`Failed to update menu ${menuId}:`, error.response?.data || error);
    throw error;
  }
};

/* ───────── Save Role Menu Access ───────── */
export const saveRoleMenuAccess = async (roleId, payload) => {
  try {
    const res = await apiClient.post(`/api/admin/role-menu-access/${roleId}`, payload);
    return res.data;
  } catch (error) {
    console.error(`Failed to save role-menu-access for role ${roleId}:`, error.response?.data || error);
    throw error;
  }
};
/* ───────── Get Permission ───────── */
export const getPermissions = async () => {
  const res = await apiClient.get(`/api/admin/permissions`);
  return res.data;
};

/* ───────── Create Menu ───────── */
export const createMenu = async (payload) => {
  try {
    const res = await apiClient.post(`/api/admin/menus`, payload);
    return res.data;
  } catch (error) {
    console.error("Failed to create menu:", error.response?.data || error);
    throw error;
  }
};
export const clearMenuCache = () => {
  setCached("MenusDropDowns", null);
};
/* ───────── Menu ───────── */
export const getMenu = async () => {
  const key = "MenusDropDowns";

  const cached = getCached(key, 60);
  if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/admin/menus`);
    setCached(key, res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch menus:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Domains ───────── */
export const getDomains = async (UserId) => {
  const key = `DomainDropDowns_${UserId}`;

  const cached = getCached(key, 60);
  if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/domains?userId=${encodeURIComponent(UserId)}`); 
    setCached(key, res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch domains:", error.response?.data || error.message);
    throw error;
  }
};

/* ───────── Get All User Roles ───────── */
export const getUserRoles = async () => {
  const key = "UserRoles";

  // const cached = getCached(key, 60);
  // if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/userroles`);
    const data = res.data || [];
    // setCached(key, data);
    return data;
  } catch (error) {
    console.error("Failed to fetch user roles:", error);
    throw error;
  }
};

/* ───────── Roles ───────── */
export const getRoles = async (domain) => {
  if (!domain) throw new Error("domain is required");

  const key = `Roles_${domain}`;

  const cached = getCached(key, 60);
  if (cached) return cached;

  try {
    const res = await apiClient.get(
      `/api/roles?domain=${encodeURIComponent(domain)}`
    );
    const data = res.data || [];
    setCached(key, data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch roles`, error);
    throw error;
  }
};

/* ───────── Providers ───────── */
export const getProvidersByCompany = async (domain, companyId) => {
  if (!domain) throw new Error("domain is required");
  if (!companyId) throw new Error("companyId is required");

  const key = `Providers_${domain}_${companyId}`;

  const cached = getCached(key, 30);
  if (cached) return cached;

  try {
    const res = await apiClient.get(
      `/api/providers?domain=${encodeURIComponent(domain)}&companyId=${encodeURIComponent(companyId)}`
    );
    const data = res.data || [];
    setCached(key, data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch providers for company ${companyId}:`, error);
    throw error;
  }
};

export const getRolesByProvider = async (domain, companyId, officeId) => {
  if (!domain) throw new Error("domain is required");
  if (!companyId) throw new Error("companyId is required");
  if (!officeId) throw new Error("officeId is required");

  const res = await apiClient.get(`/api/roles-by-provider`, {
    params: { domain, companyId, officeId },
  });
  return res.data || [];
};

export const getRolesByCompany = async (domain, companyId) => {
  if (!domain) throw new Error("domain is required");
  if (!companyId) throw new Error("companyId is required");

  const res = await apiClient.get(`/api/roles-by-company`, {
    params: { domain, companyId },
  });
  return res.data || [];
};

/* ───────── Company ───────── */
export const getCompaniesByDomain = async (domain) => {
  if (!domain) throw new Error("domain is required");

  const key = `CompaniesDropDowns_${domain}`;

  const cached = getCached(key, 30);
  if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/companies?domain=${encodeURIComponent(domain)}`);
    const data = res.data || [];
    setCached(key, data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch companies for domain ${domain}:`, error);
    throw error;
  }
};

/* ───────── Users ───────── */
export const getUsersByCompany = async (domain,company) => {
  if (!domain) throw new Error("domain is required");

  // const key = `UsersDropDowns_${domain}`;

  // const cached = getCached(key, 30);
  // if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/users-by-company?domain=${encodeURIComponent(domain)}&companyId=${encodeURIComponent(company)}`);
    const data = res.data || [];
    // setCached(key, data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch users for company ${company}:`, error);
    throw error;
  }
};

export const updateUserFeatureAccess = async (payload) => {
    const params = new URLSearchParams({
        domain: payload.domain,
        companyId: payload.companyId,
        userId: payload.userId,
        id: payload.id,
        isDisable: payload.isDisable,
        modifiedBy: payload.modifiedBy
    });

    try {
        const response = await apiClient.put(`/api/update-feature-access?${params.toString()}`, {});
        return response.data; 
    } catch (error) {
        const errorMessage = error.response?.data?.Message || error.response?.data?.message || "Failed to update feature";
        throw new Error(errorMessage);
    }
};

/* ───────── Get user access features ───────── */
export const getUserFeatures = async (domain) => {
  if (!domain) throw new Error("domain is required");

  // const key = `UserFeatures_${domain}`;

  // const cached = getCached(key, 30);
  // if (cached) return cached;

  try {
    const res = await apiClient.get(`/api/feature-names?domain=${encodeURIComponent(domain)}`);
    const data = res.data || [];
    // setCached(key, data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch user features`, error);
    throw error;
  }
};

/* ───────── Get already assigned user access features ───────── */
export const getAssignedUserAccessFeatures = async (domain,companyId,userId) => {
  if (!domain) throw new Error("domain is required");
  try {
    const res = await apiClient.get(`/api/user-feature-access?domain=${encodeURIComponent(domain)}&companyId=${encodeURIComponent(companyId)}&userId=${encodeURIComponent(userId)}`);
    const data = res.data || [];
    return data;
  } catch (error) {
    console.error(`Failed to fetch user features`, error);
    throw error;
  }
};

/* ───────── Configure a new feature for a specific user ───────── */
export const assignNewFeatureToUser = async (domain, payload) => {
  try {
    const res = await apiClient.post(
      `/api/create-user-feature-access?domain=${encodeURIComponent(domain)}`,
      payload
    );
    return res.data;
  } catch (error) {
    console.error("Failed to create feature mapping:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Doctors ───────── */
export const getDoctorsAndSpecialities = async (company, domain) => {
  try {
    const res = await apiClient.get(
      `/api/getcompanydoctors/${encodeURIComponent(company)}/doctors?domain=${encodeURIComponent(domain)}`
    );
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch doctors:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Get all templates ───────── */
export const getTemplates = async (domain) => {
  if (!domain) throw new Error("domain is required");

  try {
    const res = await apiClient.get(`/api/note-templates?domain=${encodeURIComponent(domain)}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch templates:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Configure a new template for a specific doctor ───────── */
export const createDoctorNoteTemplateMapping = async (payload) => {
  try {
    const res = await apiClient.post(`/api/AdminService/v1/DoctorNoteTemplateMapping/configureatemplate`, payload);
    return res.data;
  } catch (error) {
    console.error("Failed to create template mapping:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Get configured templates for a specific doctor ───────── */
export const getDoctorTemplates = async (domain, doctorID) => {

  try {
    const res = await apiClient.get(
      `/api/doctor-note-templates?domain=${encodeURIComponent(domain)}&doctorId=${encodeURIComponent(doctorID)}`
    );
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch doctor templates:", error.response?.data || error);
    throw error;
  }
};


/* ───────── Get configured templates for a specific doctor ───────── */
export const deleteDoctorTemplates = async (domain, doctorID, templateIds) => {

  try {
    const res = await apiClient.delete(
      `/api/delete-doctor-note-templates?domain=${encodeURIComponent(domain)}&doctorId=${encodeURIComponent(doctorID)}&templateIds=${encodeURIComponent(templateIds)}`
    );
    return res;
  } catch (error) {
    console.error("Failed to delete doctor templates:", error.response?.data || error);
    throw error;
  }
};


/* ───────── Configure a new template in the system ───────── */
export const createNoteTemplateMapping = async (domain, payload) => {
  try {
    const res = await apiClient.post(`/api/create-doctor-note-template?domain=${domain}`, payload);
    return res.data;
  } catch (error) {
    console.error("Failed to create note template mapping:", error.response?.data || error);
    throw error;
  }
};




export const uploadSpecialtyTemplate = async (domain, payload) => {
  const formData = new FormData();

  formData.append("domain", domain);
  formData.append("companyId", payload.companyId);
  formData.append("specialityName", payload.specialityName);
  formData.append("specialityCode", payload.specialityCode);
  formData.append("noteTemplateId", payload.noteTemplateId.toString());
  formData.append("jsonFile", payload.jsonFile);
  formData.append("templateFile", payload.templateFile);
  formData.append("enableDocSign", payload.enableDocSign.toString());
  formData.append("enablePatSign", payload.enablePatSign.toString());
  formData.append("enableTechSign", payload.enableTechSign.toString());
  formData.append("enableDiagnosisCode", payload.enableDiagnosisCode.toString());
  formData.append("enableProcedureCode", payload.enableProcedureCode.toString());
  formData.append("userId", "US00001")

  try {
    const res = await apiClient.post(`/api/template-configuration/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
  } catch (err) {
    console.error("Template upload failed", err);
    throw err;
  }
};

/* ───────── User Account Mapping Start ───────── */
export const getAllUsers = async (domain) => {
  try {
    const res = await apiClient.get(`/api/admin/users?domain=${domain}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch users:", error.response?.data || error);
    throw error;
  }
};

export const getCompaniesForMapping = async (userId, domain) => {
  try {
    const res = await apiClient.get(`/api/admin/companies-for-mapping?userId=${userId}&domain=${domain}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch companies for mapping:", error.response?.data || error);
    throw error;
  }
};

export const getMappedCompanies = async (userId, domain) => {
  try {    
    const res = await apiClient.get(`/api/admin/user-company-mapping?userId=${userId}&domain=${domain}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch mapped companies:", error.response?.data || error);
    throw error;
  }
};

export const addUserCompanyMapping = async (domain, userId, companyIds) => {
  try {
    const res = await apiClient.post(`/api/admin/user-company-mapping?domain=${domain}`, { userId, companyIds });
    return res.data;
  } catch (error) {
    console.error("Failed to add user company mapping:", error.response?.data || error);
    throw error;
  }
};

export const deleteUserCompanyMapping = async (domain, userId, mappedUserIds) => {
  try {
    const res = await apiClient.delete(`/api/admin/user-company-mapping?domain=${domain}`, { data: { userId, mappedUserIds } });
    return res.data;
  } catch (error) {
    console.error("Failed to delete user company mapping:", error.response?.data || error);
    throw error;
  }
};
/* ───────── User Account Mapping End ───────── */

/* ───────── Intake Sheet Start ───────── */

export const getAllIntakeSheets = async (CompanyId, domain) => {
  try {
    const res = await apiClient.get(`/api/admin/intakesheet?companyId=${CompanyId}&domain=${encodeURIComponent(domain)}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch Intake Sheets:", error.response?.data || error);
    throw error;
  }
};

export const assignIntakeSheets = async (companyId, formIds, domain) => {
  try {
    const res = await apiClient.post(`/api/admin/assign`, {
      companyId,
      formIds,
      domain
    });
    return res.data || {};
  } catch (error) {
    console.error("Failed to assign Intake Sheets:", error.response?.data || error);
    throw error;
  }
};

export const deleteIntakeSheetMapping = async (companyId, formIds, domain) => {
  try {
    const res = await apiClient.delete(`/api/admin/delete`, {
      data: { companyId, formIds, domain } 
    });
    return res.data || {};
  } catch (error) {
    console.error("Failed to delete Intake Sheet mappings:", error.response?.data || error);
    throw error;
  }
};
/* ───────── Intake Sheet End ───────── */

/* ───────── Kiosk Allowed Companies Start ───────── */
// Backs dbo.mst_KioskAllowedCompany — the companies the Kiosk menu/feature is enabled for,
// replacing the Doctor frontend's hardcoded KIOSK_ALLOWED_COMPANY_IDS array.

export const getKioskAllowedCompanies = async (domain, status) => {
  try {
    const params = { domain };
    if (status !== undefined && status !== null) params.status = status;
    const res = await apiClient.get(`/api/admin/kioskallowedcompanies`, { params });
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch Kiosk allowed companies:", error.response?.data || error);
    throw error;
  }
};

export const addKioskAllowedCompany = async (companyId, domain) => {
  try {
    const res = await apiClient.post(`/api/admin/kioskallowedcompanies`, {
      companyId,
      domain,
    });
    return res.data || {};
  } catch (error) {
    console.error("Failed to add Kiosk allowed company:", error.response?.data || error);
    throw error;
  }
};

export const updateKioskAllowedCompany = async (id, { companyId, status } = {}, domain) => {
  try {
    const res = await apiClient.put(`/api/admin/kioskallowedcompanies/${id}`, {
      id,
      companyId,
      status,
      domain,
    });
    return res.data || {};
  } catch (error) {
    console.error(`Failed to update Kiosk allowed company ${id}:`, error.response?.data || error);
    throw error;
  }
};

// Soft delete — disables the company (Status = false) rather than removing its row.
export const deleteKioskAllowedCompany = async (id, domain) => {
  try {
    const res = await apiClient.delete(`/api/admin/kioskallowedcompanies/${id}`, {
      params: { domain },
    });
    return res.data || {};
  } catch (error) {
    console.error(`Failed to disable Kiosk allowed company ${id}:`, error.response?.data || error);
    throw error;
  }
};
/* ───────── Kiosk Allowed Companies End ───────── */

/* ───────── Referral Template Start ───────── */
export const getReferralTemplatesByCompany = async (companyId, domain) => {
  try {
    const res = await apiClient.get(`/api/admin/referraltemplate`, {
      params: { companyId, domain } 
    });
    return res.data || [];
  } catch (error) {
    console.error("Failed to fetch Referral Templates:", error.response?.data || error);
    throw error;
  }
};

export const assignReferralTemplates = async (companyId, templateIds, domain) => {
  try {
    const res = await apiClient.post(`/api/admin/referraltemplate/assign`, templateIds, {
      params: { companyId, domain },
      headers: { 'Content-Type': 'application/json' }
      }
    );
    return res.data || {};
  } catch (error) {
    console.error("Failed to assign Referral Templates:", error.response?.data || error);
    throw error;
  }
};

export const deleteReferralTemplateMapping = async (companyId, templateIds, domain) => {
  try {
    const res = await apiClient.delete(`/api/admin/referraltemplate/delete`, {
      params: { companyId, domain },
      data: templateIds,
      headers: { 'Content-Type': 'application/json' }
      }
    );
    return res.data || {};
  } catch (error) {
    console.error("Failed to delete Referral Template mappings:", error.response?.data || error);
    throw error;
  }
};
/* ───────── Referral Template End ───────── */

/* ───────── Supervising Doctor start ───────── */
export const manageSupervisingDoctor = async (doctorId, supervisingDoctorId = null, domain) => {
    const response = await apiClient.post(
        `/api/admin/supervisingdoctor/addupdate?domain=${encodeURIComponent(domain)}`,
        { doctorId, supervisingDoctorId }
    );
    return response.data;
};
/* ───────── Supervising Doctor end ───────── */
/* ───────── Forgot Password ───────── */
export const forgotPassword = async (username) => {
  try {
    const res = await apiClient.post(`api/auth/forgot-password`, { username });
    return res.data;
  } catch (error) {
    console.error("Failed to send OTP:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Verify OTP ───────── */
export const verifyOtp = async (username, otp) => {
  try {
    const res = await apiClient.post(`api/auth/verify-otp`, { username, otp });
    return res.data;
  } catch (error) {
    console.error("Failed to verify OTP:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Resend OTP ───────── */
export const resendOtp = async (username) => {
  try {
    const res = await apiClient.post(`api/auth/send-otp`, { username });
    return res.data;
  } catch (error) {
    console.error("Failed to resend OTP:", error.response?.data || error);
    throw error;
  }
};
/* ───────── Reset Password ───────── */
export const resetPassword = async (username, newPassword) => {
  try {
    const res = await apiClient.post(`api/auth/reset-password`, { userName: username, newPassword });
    return res.data;
  } catch (error) {
    console.error("Failed to reset password:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Get Account Lock Status ───────── */
export const getLockStatus = async (username) => {
  try {
    const res = await apiClient.get(`/api/auth/lock-status?username=${encodeURIComponent(username)}`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch lock status:", error.response?.data || error);
    throw error;
  }
};

/* ───────── Configure Provider Login ───────── */

export const getUsersBySearch = async (domain, search = '') => {
  if (!domain) throw new Error("domain is required");

  try {
    const res = await apiClient.get('/api/admin/providerlogin/users', {
      params: { domain, search: search.trim() }
    });
    return res.data || [];
  } catch (error) {
    console.error("Failed to search users:", error);
    throw error;
  }
};

export const getOfficesByCompany = async (domain, companyId) => {
  if (!domain) throw new Error("domain is required");
  if (!companyId) throw new Error("companyId is required");

  try {
    const res = await apiClient.get('/api/admin/providerlogin/offices', {
      params: { domain, companyId }
    });
    return res.data || [];
  } catch (error) {
    console.error(`Failed to fetch offices for company ${companyId}:`, error);
    throw error;
  }
};

export const getProviderLoginMappings = async (domain, companyId) => {
  if (!domain) throw new Error("domain is required");
  if (!companyId) throw new Error("companyId is required");

  try {
    const res = await apiClient.get('/api/admin/providerlogin/mappings', {
      params: { domain, companyId }
    });
    return res.data || [];
  } catch (error) {
    console.error(`Failed to fetch mappings for company ${companyId}:`, error);
    throw error;
  }
};

export const configureProviderLogin = async (payload) => {
  try {
    const res = await apiClient.post('/api/admin/providerlogin/configure', payload);
    return res.data;
  } catch (error) {
    console.error("Failed to configure provider login:", error);
    throw error;
  }
};

/* ───────── manage Failed Bulk Billing Company Config ───────── */
export const manageFailedBulkBillingCompanyConfig = async (payload) => {
  try {
    const res = await apiClient.post('/api/FailedBulkBillingCompanyConfig', payload);
    return res.data;
  } catch (error) {
    console.error("Failed to manage bulk billing company config:", error);
    throw error;
  }
};

export const getFailedBulkBillingCompanyConfigs = async (domain) => {
  try {
    const res = await apiClient.get('/api/FailedBulkBillingCompanyConfig', {
      params: { domain }
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch bulk billing company configs:", error);
    throw error;
  }
};
/* ───────── Incorrect Json Note  ───────── */
export const getIncorrectJsonNotes = async (domain, params = {}) => {
    const response = await apiClient.get('/api/IncorrectJsonNote', {
        params: {
            domain,
            companyId:   params.companyId,
            templateIds: params.templateIds,
            fromDate:    params.fromDate,
            toDate:      params.toDate,
        },
        paramsSerializer: (p) => {
            const searchParams = new URLSearchParams();
            Object.entries(p).forEach(([key, value]) => {
                if (value === undefined || value === null) return;
                if (Array.isArray(value)) {
                    value.forEach(v => searchParams.append(key, v));
                } else {
                    searchParams.append(key, value);
                }
            });
            return searchParams.toString();
        },
    });
    return response;
};

export const getVisitNoteJsonDetails = (domain, eventId) => {
    return apiClient.get(`/api/IncorrectJsonNote/json-details`, {
        params: { eventId, domain },
    });
};

/* ───────── Create a new user role domain mapping ───────── */
export const createRoleDomainMapping = async (payload, domain) => {
  try {
    const domainStr = typeof domain === 'string' ? domain : 'greenyourbills.com';

    const res = await apiClient.post(
      `/api/RoleDomainMappings?domain=${encodeURIComponent(domainStr)}`, 
      payload, 
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return res.data;
  } catch (error) {
    console.error("Failed to create role domain mapping:", error.response?.data || error.message);
    throw error;
  }
};

  /* ───────── Get all configured role domain mappings ───────── */
  export const getAllRoleDomainMappings = async (domain) => {
    try {
      const res = await apiClient.get(`/api/RoleDomainMappings?domain=${encodeURIComponent(domain)}`);
      return res.data || [];
    } catch (error) {
      console.error("Failed to fetch all role domain mappings:", error.response?.data || error.message);
      throw error;
    }
  };

  /* ───────── Get a specific role domain mapping by its ID ───────── */
  export const getRoleDomainMappingById = async (id,domain) => {
    try {
      const res = await apiClient.get(`/api/RoleDomainMappings/${encodeURIComponent(id)}?domain=${encodeURIComponent(domain)}`);
      return res.data;
    } catch (error) {
      console.error(`Failed to fetch role domain mapping for ID ${id}:`, error.response?.data || error.message);
      throw error;
    }
  };

  /* ───────── Update flags/status of an existing mapping by ID ───────── */
  export const updateRoleDomainMapping = async (id,domain, payload) => {
    try {
      const res = await apiClient.put(`/api/RoleDomainMappings/${encodeURIComponent(id)}?domain=${encodeURIComponent(domain)}`, payload);
      return res.data;
    } catch (error) {
      console.error(`Failed to update role domain mapping for ID ${id}:`, error.response?.data || error.message);
      throw error;
    }
  };

  export const getAllDomainsLookup = async (domain) => {
  const response = await apiClient.get(`/api/GetDomain?domain=${encodeURIComponent(domain)}`);
  return response.data;
};

/* ───────── User Domain Mapping ───────── */
export const saveUserDomainAccess = async (payload) => {
  const res = await apiClient.post('/api/userdomain/domain-access', payload);
  return res.data;
};

export const UpdateUserDomainAccess = async (payload) => {
  const res = await apiClient.post('/api/userdomain/domain-access/update', payload);
  return res.data;
};

export const getUserDomainAccess = async (userId,domain) => {
  const res = await apiClient.get(`/api/userdomain/${userId}/domain-access?domain=${encodeURIComponent(domain)}`);
  return res.data;
};

export const getUserDomainAccessIncludingInactive = async (userId, domain) => {
  const res = await apiClient.get(`/api/userdomain/${userId}/domain-access-all?domain=${encodeURIComponent(domain)}`);
  return res.data;
};

export const updateAdminUser = async (payload) => {
  const response = await apiClient.post('/api/adminusers/update', payload);
  return response.data;
};

export const getCompanyByAccountType = async (type, domain) => {
  const res = await apiClient.get(`/api/GetCompanyByAccountType?Type=${type}&domain=${encodeURIComponent(domain)}`);
  return res.data;
};

export const getNextCompanyPrefix = async (length, domain) => {
  const res = await apiClient.get(`/api/GetNextCompanyPrefix?length=${length}&domain=${encodeURIComponent(domain)}`);
  return res.data.prefix;
};

export async function registerAccount(payload, { signal } = {}) {
  try {
    const res = await apiClient.post('/api/AccountRegistration/register', payload, { signal });
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ??
      err.response?.data?.title ??
      'Registration failed. Please try again.';

    const error = new Error(message);
    error.status = err.response?.status;
    throw error;
  }
}

export async function getRegistrationStatus(requestId, domain, { signal } = {}) {
    const url = await apiClient.get(`/api/AccountRegistration/status/${requestId}?domain=${encodeURIComponent(domain)}`, { signal });
    //url.searchParams.set('domain', domain);

    const res = await fetch(url, { signal });
    if (res.status === 404) return null;
    if (!res.ok) throw new Error('Failed to fetch registration status.');
    return res.json();
}

export const getDMEDataEntryReport = async (payload) => {
  const response = await apiClient.post('/api/reports/GetDMEDataEntryReport', payload);
  return response.data;
};

export const getAICheckPostingReport = async (payload) => {
  const response = await apiClient.post('/api/reports/GetAICheckPostingReport', payload);
  return response.data;
};

export const getLatestPrefix = async (domain, opts = {}) => {
    const response = await apiClient.get('/api/AccountRegistration/latest-prefix', {
        params: { domain },
        ...opts,
    });
    return response.data; // { prefix: "XX" }
  }
  
export const getAIVerificationSummaryReport = async (payload) => {
  const response = await apiClient.post('/api/reports/GetAIVerificationSummaryReport', payload);
  return response.data;
};

export const getBillingReport = async (payload) => {
  const response = await apiClient.post('/api/reports/GetBillingReport', payload);
  return response.data;
};

export const getMedicalNoteTemplateUsage = async (payload) => {
  const res = await apiClient.post("/api/reports/GetMedicalNoteTemplateUsage", payload);
  return res.data;
};

export const getEHREventVisitSearch = async (payload) => {
  const res = await apiClient.post("/api/reports/GetEHREventVisitSearch", payload);
  return res.data;
};

export const getMedicalNoteTemplateUsageDetails = async (payload) => {
  const res = await apiClient.post("/api/reports/GetMedicalNoteTemplateUsageDetails", payload);
  return res.data;
};

export const getDocumentGenerationServiceLogs = (payload) =>
  apiClient.post("/api/reports/GetDocumentGenerationServiceLogs", payload);

export const getDocumentGenerationApiLogs = (payload) =>
  apiClient.post("/api/reports/GetDocumentGenerationApiLogs", payload);

export const getMonthlyElectronicSubmissionReport = async (payload) => {
  const res = await apiClient.post("/api/reports/GetMonthlyElectronicSubmissionReport", payload);
  return res?.data ?? res;
};

export const getMonthlyFaxReport = async (payload) => {
  const res = await apiClient.post("/api/reports/GetMonthlyFaxReport", payload);
  return res?.data ?? res;
};

export const getWeeklyPaymentReport = (payload) =>
  apiClient.post("/api/reports/GetWeeklyPaymentReport", payload).then((res) => res.data);

export const getLawFirms = async (domain) => {
  const { data } = await apiClient.get(`/api/reports/GetLawFirms`, {
    params: { domain },
  });
  return data;
};

export const getMonthlyCaseTransferReport = async (payload) => {
  const { data } = await apiClient.post(
    `/api/reports/GetMonthlyCaseTransferReport`,
    payload
  );
  return data;
};

// Get registration history
export const getRegistrationHistory = async (filters = {}, options = {}) => {
  const params = new URLSearchParams();
  if (filters.accountType) params.append('AccountType', filters.accountType);
  if (filters.status) params.append('Status', filters.status);
  if (filters.startDate) params.append('StartDate', filters.startDate);
  if (filters.endDate) params.append('EndDate', filters.endDate);
  if (filters.domain) params.append('Domain', filters.domain);
  params.append('PageNumber', filters.pageNumber || 1);
  params.append('PageSize', filters.pageSize || 20);

  const response = await apiClient.get(
    `/api/AccountRegistration/gybaccount/search?${params.toString()}`,
    options
  );
  return response.data;
};

export const rollbackRegistration = async (record) => {
  const payload = {
    requestId: record.requestId,
    accountType: record.accountTypeKey || '',
    companyName: record.companyName || '',
    baseAccount: record.baseCompanyId || record.baseAccount || '',
    companyId: record.newCompanyID ||'',
    contactFirstName: '',
    contactLastName: '',
    email: '',
    address1: '',
    city: '',
    zip: '',
    state: '',
    companyPrefix: '',
    domain: record.domainID || record.domain || '',
    password: '',
    username: record.userName || '',
    officePhone: '',
    procedureCodes: false,
    receiverEmail: sessionStorage.getItem('userEmail') || '',
    userId:record.userId || '',
    isRollback: true,
  };

  const response = await apiClient.post(
    '/api/AccountRegistration/register',
    payload
  );
  return response.data;
};

/* ---------Notification Settings ---------------- */
export const getNotificationSetting = async (notificationKey) => {
  try {
    const res = await apiClient.get(`/api/admin/notificationsetting/${notificationKey}`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch notification setting:", error.response?.data || error);
    throw error;
  }
};

export const toggleNotificationSetting = async (payload) => {
  try {
    const res = await apiClient.post(`/api/admin/notificationsetting/toggle`, payload);
    return res.data;
  } catch (error) {
    console.error("Failed to update notification setting:", error.response?.data || error);
    throw error;
  }
};
